import types from './types';
import API from '../../lib/api';
import {navigate} from '../../utils/navigation';
import {toast} from 'react-toastify';
import ModalsLib from '../../lib/modals';

export const loadBoxes = () => async dispatch => {
    const response = await API.call({
        path: "/lootbox/getBoxes"
    });

    if(response.success) 
        dispatch({ 
            type: types.loaded,
            payload: {
                boxes: response.boxes
            }
        });
}

export const loadBox = slug => async dispatch => {
    const response = await API.call({
        path: "/lootbox/get",
        body: {
            slug
        }
    });

    if(response.success)
        dispatch({
            type: types.box.loaded,
            payload: response.box
        });
    else
        navigate('/tasks');
}

export const openLoot = slug => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'open'
    });

    const response = await API.call({
        path: '/lootbox/open',
        body: {
            slug
        }
    }); 

    dispatch({
        type: types.toggleButton,
        payload: 'open'
    });

    if(response.success) {
        dispatch({
            type: types.box.update,
            payload: response.data
        });

        setTimeout(() => {
            dispatch({
                type: types.box.update,
                payload: {
                    state: "prize"
                }
            })
        }, 8e3);
    } else {
        toast.dismiss();
        toast.error(response.error);
    }
}

export const sellPrize = id => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'prize_sell'
    });

    const response = await API.call({
        path: '/lootbox/sell',
        body: {
            id
        }
    }); 

    dispatch({
        type: types.toggleButton,
        payload: 'prize_sell'
    });

    if(response.success) {
        dispatch({
            type: types.box.update,
            payload: {
                state: 'preview'
            } 
        });

        toast.dismiss();
        toast.success(response.message);
    } else {
        toast.dismiss();
        toast.error(response.error);
    }
}

export const redeemPrize = id => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'prize_redeem'
    });

    const response = await API.call({
        path: '/lootbox/redeem',
        body: {
            id
        }
    }); 

    dispatch({
        type: types.toggleButton,
        payload: 'prize_redeem'
    });

    if(response.success) {
        dispatch({
            type: types.box.update,
            payload: {
                state: 'preview'
            } 
        });

        toast.dismiss();
        toast.success(response.message);
    } else { 
        toast.dismiss();
        toast.error(response.error);
    }
}

export const redeemLootFreeplay = data => async dispatch => {
    console.log(data);

    dispatch({
        type: types.toggleButton,
        payload: 'prize_redeem'
    });

    const response = await API.call({
        path: '/lootbox/redeemFreeplay',
        body: data
    }); 

    dispatch({
        type: types.toggleButton,
        payload: 'prize_redeem'
    });

    if(!response.success) {
        toast.dismiss();
        toast.error(response.error);
    } else {
        toast.dismiss();
        toast.success(response.message);

        dispatch({
            type: types.box.update,
            payload: {
                prize_status: 1
            }
        });

        navigate(`/game/${response.game}`);
        ModalsLib.close();
    }
}
